// Реализация бургер-меню
import { burger } from "../functions/burger";
